'use client';

import { Button } from '@radix-ui/themes';
import { useFormStatus } from 'react-dom';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

type RequestEmailPageProps = {
  params: Promise<{ locale: string }>;
};

export default function RequestEmailPage({ params }: RequestEmailPageProps) {
  const message = useSearchParams().get('message');
  const { pending } = useFormStatus();
  const t = useTranslations('KidsLogin/RequestEmail');

  return (
    <>
      <div className=" my-8 uppercase font font-titillium-web font-black text-center text-7xl">
        <span className="pl-1 pr-2 border-black border-3  rounded-tr-full bg-goldenrod text-wheat">K</span>ids{' '}
        <span className="px-2 border-black border-3 rounded-t-full bg-red text-wheat">L</span>ogi
        <span className="pl-1 pr-3 border-black border-3 rounded-r-full bg-dark-slate-blue text-light-steel-blue">
          N
        </span>
      </div>
      {message ? (
        <div className="bg-gray-300 text-center text-lg m-4 p-4">{message}</div>
      ) : (
        <form action="/api/email_parents">
          <p className="flex flex-col place-items-center text-center p-4 gap-4 ">
            {t('EmailInstructions')}
            <input
              required
              name="email"
              type="email"
              className="w-56 bg-white border-black border-3 p-1 text-sm focus:border-[#3898ec] focus:outline-none "
            />
            {/* <input type="hidden" name="locale" value={params.locale} /> */}
            <Button
              type="submit"
              disabled={pending}
              className="bg-dark-slate-blue border-black rounded-none border-3 text-xl text-white lowercase"
            >
              {pending ? t('PleaseWait') : t('Submit')}
            </Button>
          </p>
        </form>
      )}
    </>
  );
}
